export enum DeviceSettingsProperties {
  Name = 'name',
  Description = 'description',
  Value = 'value',
  DeviceSettingType = 'deviceSettingType',
  Zone = 'zone',
  Released = 'released',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
}
export enum DeviceSettingsMetaProperties {
  ZoneId = 'Zone-id',
  ZoneVersion = 'Zone-version',
}
